import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'; // 状态管理器
import axios from 'axios';  // axios
import ElementUI from 'element-ui'; // vue ui
import 'element-ui/lib/theme-chalk/index.css'; // element-ui.css
import {VTable,VPagination} from 'vue-easytable'
import scroll from 'vue-seamless-scroll'
const moment = require('moment')
// 注册到全局
Vue.use(scroll)
Vue.prototype.moment = moment;
Vue.component(VTable.name, VTable)
Vue.component(VPagination.name, VPagination)
Vue.use(ElementUI, { size: 'small' });
Vue.prototype._ = require('lodash');
Vue.prototype.$axios = axios;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js